/**
 * resolveFormDeriveSourceRowSkip
 *
 * True when an ArTable row does NOT participate as a derive source. The
 * population is exactly the one `computeAggregations` folds over, so header
 * exclusion is UNCONDITIONAL and this takes no `bundlesEnabled` parameter.
 * Two surprises worth stating: `suppressFormulas` rows DO participate — they
 * contribute their stored values, matching aggregation semantics — and
 * derive-owned rows DO participate, because topological order handles chaining.
 */

import { AR_TABLE_AGGREGATIONS_ROW_ID } from '../System.Artifacts.types';
import type { ArRowData, ArRowId } from '../System.Artifacts.types';

function resolveFormDeriveSourceRowSkip(
  rowId: ArRowId,
  data: Partial<ArRowData> | undefined,
): boolean {
  return rowId === AR_TABLE_AGGREGATIONS_ROW_ID || data?.bundleRole === 'header';
}

export { resolveFormDeriveSourceRowSkip };
